import _ from 'lodash';
import moment from 'moment';
import { getBranchesV2Succeed, getBranchesV2Failure
} from '../actions';
import { getBranchesSnapshots }
from 'common/services/branches.service';

export const getBranchesV2 = params => async dispatch => {
  try {
    const shouldPassPit =
      moment(params.point_in_time).date() === moment().date() ? false : true;
    const response = await getBranchesSnapshots(
      shouldPassPit ? params : _.omit(params, ['point_in_time'])
    );
    dispatch(getBranchesV2Succeed(response));
    return response;
  } catch (e) {
    window.TrackJS && window.TrackJS.track(e);
    dispatch(getBranchesV2Failure());
    return Promise.reject(e);
  }
};
